<template>
    <div class="no-data">
        <img src="@/assets/mobile-imgs/no-data-img.png" class="no-data__img" />
        <div class="no-data__font">暂无内容</div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.no-data {
    width: 100%;
    text-align: center;
    background: #f9fbfe;
    &__img {
        width: 162px;
        height: 126px;
        margin: 80px auto 10px;
    }
    &__font {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
    }
}
</style>
